export default __webpack_public_path__ + "static/awards-pc-cl-15c7c9f67c7bc5b57ff0bb69224903b9.png";